import { createActionTypes } from 'utils/action/actionTypes';

export const FETCH_MODULE = createActionTypes('FETCH_MODULE');
export const GET_MODULE = createActionTypes('GET_MODULE');
export const CREATE_MODULE = createActionTypes('CREATE_MODULE');
export const UPDATE_MODULE = createActionTypes('UPDATE_MODULE_SUPER');
export const DELETE_MODULE = createActionTypes('DELETE_MODULE');
export const MANAGE_MODULE = createActionTypes('MANAGE_MODULE');
export const FETCH_MODULE_SORTED = createActionTypes('FETCH_MODULE_SORTED');
